<template>
    <div>
		<div  v-if="editorList.length > 0">
			<br><br>
		</div>
        <div v-for="(editorID, editorIndex) in editorList" :key="editorIndex">
			<span style="font-size: 115%; font-weight: bold;">
				{{editorIndex+1}}) {{editorID}}
			</span>
			<md-button 
				class="md-icon-button md-accent md-raised md-dense" 
				style="margin-top: -6px; margin-left: 6px; transform: scale(0.8)"
				@click="deleteEditor(editorIndex, editorID)"
			>
				<md-icon>delete_forever</md-icon>
			</md-button>
        </div>
		<br>
        <md-field style="display: inline-block; width: 70%;">
            <label>New Editor Email</label>
            <md-input v-model="newEditor" style="width: 100%;">	
			</md-input>
        </md-field>
		<md-button 
			class="md-icon-button md-primary md-raised md-dense" 
			style="margin-top: 16px; margin-left: 6px; transform: scale(0.9)"
			@click="addEditor"
		>
			<md-icon>add</md-icon>
		</md-button>
    </div>
</template>

<script>
	import APIRequests from "../APIRequests.js"
    export default {
		props: {
			caseID: {
				type: String
			},
		},
		data: function(){
			return {
				editorList: [],
				newEditor: ""
			}
		},
		methods: {
			fetchEditorList: function(){
				APIRequests.getJSONData(
					this.$store.state.api_url + "/api/editor/" + this.caseID + "/editorList", 
					this.$store.state.jwtToken
				).then((data) => {
					this.editorList = data
					if(!this.editorList) this.editorList = []
				}).catch(([xhrStatus, xhrResp]) => {
					this.$emit("notify", "Failed to fetch editor list: " + xhrStatus + " - " + xhrResp)
				})
			},
			addEditor: function(){
				if(this.newEditor == "") return
				if(this.editorList.includes(this.newEditor)){
					this.$emit("notify", "Editor has already been added to the list!")
					this.newEditor = ""
					return
				}
				APIRequests.postJSONData(
					this.$store.state.api_url + "/api/editor/" + this.caseID + "/addEditor", 
					this.newEditor,
					this.$store.state.jwtToken
				).then(() => {
					this.$emit("notify", "Added editor: " + this.newEditor)
					this.editorList.push(this.newEditor)
					this.newEditor = ""
				}).catch((xhrResp) => {
					this.$emit("notify", "Failed to add new editor: " + xhrResp[1])
				})
			},
			deleteEditor: function(editorIndex, editorID){
				APIRequests.postJSONData(
					this.$store.state.api_url + "/api/editor/" + this.caseID + "/deleteEditor", 
					editorID,
					this.$store.state.jwtToken
				).then(() => {
					this.$emit("notify", "Removed editor: " + editorID)
					this.editorList.splice(editorIndex, 1)
				}).catch((xhrResp) => {
					this.$emit("notify", "Failed to add new editor: " + xhrResp[1])
				})
			}
		},
		mounted: function(){
			this.$nextTick(function() {
				this.fetchEditorList()
			})
		}
    }
</script>